import { inject, Injectable } from '@angular/core';
import { GlobalService } from '@zaoblako/web/core/services/global.service';

@Injectable({
  providedIn: 'root'
})
export class BaseAccessService<K extends string> {
  protected readonly globalService = inject(GlobalService);
  protected constructor(protected readonly rulesConst: Record<K, any>) {}

  public checkRule(ruleKey: K): boolean {
    const rule = this.rulesConst[ruleKey];
    return rule ? this.globalService.isAccessRule(rule) : false;
  }

  protected mapRules<T extends string>(map: Record<T, K>): Record<T, boolean> {
    const result = {} as Record<T, boolean>;
    for (const key in map) {
      result[key] = this.checkRule(map[key]);
    }
    return result;
  }
}
